// extracted by mini-css-extract-plugin
var _1 = "fDC_F";
export { _1 as "base" }
